import { useEffect, useState } from "react";
import api from "../../../services/api";

export const FetchStatus = {
  SUCCESS: "success",
  ERROR: "error",
  LOADING: "loading"
};

export const useFetchFiles = () => {
  const [status, setStatus] = useState(FetchStatus.LOADING);
  const [data, setData] = useState(null);

  const fetchData = () => {
    api
      .get(`/acordo/processamento/`)
      .then(({ data }) => {
        setData(data);
        setStatus(FetchStatus.SUCCESS);
      })
      .catch(err => {
        console.error(err);
        setStatus(FetchStatus.ERROR);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      console.log("Fetching xlsx list...");

      api.get(`/acordo/processamento/`).then(({ data }) => {
        setData(data);
      });
    }, [8000]); // 8 sec

    return () => {
      clearInterval(timer);
    };
  }, []);

  return {
    status,
    data,
    refresh: fetchData
  };
};



// WEBPACK FOOTER //
// ./src/pages/Acordos/AtualizarParcelasLote/use-fetch-files.js